import styled from 'styled-components';

export const CheckoutContainer = styled.div`
  background: var(--bg-section);
  min-height: calc(100vh - 68px);
  padding: 40px 20px 72px;
`;

export const CheckoutContent = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 5fr 7fr;
  gap: 28px;
  align-items: start;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

export const BookingSummary = styled.aside`
  position: sticky;
  top: 92px;

  @media (max-width: 860px) {
    position: static;
    order: 2;
  }
`;

export const SummaryCard = styled.div`
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  padding: 28px;
  box-shadow: var(--shadow-sm);

  h2 {
    font-size: var(--text-xl);
    margin-bottom: 20px;
  }
`;

export const ActivityInfo = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-light);
  margin-bottom: 16px;

  h3 {
    font-size: var(--text-lg);
    margin-bottom: 4px;
  }

  p {
    color: var(--text-secondary);
    font-size: var(--text-sm);
  }
`;

export const BookingDetails = styled.div`
  margin-bottom: 16px;

  .detail-row {
    display: flex;
    justify-content: space-between;
    padding: 7px 0;
    font-size: var(--text-sm);

    span:first-child { color: var(--text-secondary); }
    span:last-child { font-weight: 600; color: var(--text-primary); }
  }
`;

export const PriceBreakdown = styled.div`
  background: var(--bg-section);
  border-radius: var(--radius-md);
  padding: 16px;

  .price-row {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    font-size: var(--text-sm);
    color: var(--text-secondary);
  }

  .divider {
    border-top: 1px dashed var(--border-medium);
    margin: 10px 0;
  }
`;

export const TotalAmount = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: var(--text-lg);
  font-weight: 700;
  color: var(--text-primary);

  span:last-child { color: var(--secondary); }
`;

export const PaymentSection = styled.section``;

export const PaymentCard = styled.div`
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  padding: 32px;
  box-shadow: var(--shadow-sm);

  h2 {
    font-size: var(--text-xl);
    margin-bottom: 20px;
  }

  h3 {
    font-size: var(--text-base);
    font-weight: 600;
    margin: 22px 0 12px;
    color: var(--text-primary);
  }

  @media (max-width: 560px) {
    padding: 22px 16px;
  }
`;

export const LoginPrompt = styled.div`
  margin-bottom: 8px;

  p {
    font-size: var(--text-sm);
    color: var(--text-secondary);
  }

  button {
    background: none;
    border: none;
    color: var(--primary);
    font-weight: 600;
    font-size: var(--text-sm);
    cursor: pointer;
    padding: 0;
    font-family: var(--font-brand);

    &:hover { text-decoration: underline; }
  }

  .divider {
    display: flex;
    align-items: center;
    gap: 12px;
    color: var(--text-muted);
    font-size: var(--text-xs);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 16px 0 4px;

    &::before, &::after {
      content: '';
      flex: 1;
      border-top: 1px solid var(--border-light);
    }
  }
`;

export const CardFieldWrap = styled.div`
  background: var(--bg-input);
  border: 1.5px solid transparent;
  border-radius: var(--radius-md);
  padding: 14px;
  transition: border-color var(--transition-fast), background var(--transition-fast), box-shadow var(--transition-fast);

  &:focus-within {
    background: var(--white);
    border-color: var(--border-focus);
    box-shadow: 0 0 0 4px var(--focus-ring);
  }
`;

export const SecureNote = styled.p`
  font-size: var(--text-xs);
  color: var(--text-muted);
  margin-top: 8px;
`;

export const PolicyBox = styled.div`
  margin-top: 24px;
  padding: 16px;
  background: var(--success-subtle);
  border: 1px solid var(--success-light);
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  color: var(--text-secondary);

  strong {
    display: block;
    color: var(--success-dark);
    margin-bottom: 6px;
  }

  p { margin: 4px 0; }
`;
